/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestGetQuoteModalQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type RequestGetQuoteModalQuery = { projectOutgoingQuotes: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'ProjectOutgoingQuoteConnection', totalCount: number, edges: Array<{ __typename: 'OutgoingQuoteEdge', node: { __typename: 'OutgoingQuote', id: string, title: string, rootItemId: string } }> } };

export type RequestGetQuoteModal_QuoteFragment = { __typename: 'OutgoingQuote', id: string, title: string, rootItemId: string };

export const RequestGetQuoteModal_QuoteFragmentDoc = gql`
    fragment RequestGetQuoteModal_Quote on OutgoingQuote {
  id
  title
  rootItemId
}
    `;
export const RequestGetQuoteModalDocument = gql`
    query RequestGetQuoteModal($projectId: ID!) {
  projectOutgoingQuotes(limit: 0, projectId: $projectId) {
    ... on ProjectOutgoingQuoteConnection {
      edges {
        node {
          id
          ...RequestGetQuoteModal_Quote
        }
      }
      totalCount
    }
  }
}
    ${RequestGetQuoteModal_QuoteFragmentDoc}`;

/**
 * __useRequestGetQuoteModalQuery__
 *
 * To run a query within a React component, call `useRequestGetQuoteModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestGetQuoteModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestGetQuoteModalQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRequestGetQuoteModalQuery(baseOptions: Apollo.QueryHookOptions<RequestGetQuoteModalQuery, RequestGetQuoteModalQueryVariables> & ({ variables: RequestGetQuoteModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestGetQuoteModalQuery, RequestGetQuoteModalQueryVariables>(RequestGetQuoteModalDocument, options);
      }
export function useRequestGetQuoteModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestGetQuoteModalQuery, RequestGetQuoteModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestGetQuoteModalQuery, RequestGetQuoteModalQueryVariables>(RequestGetQuoteModalDocument, options);
        }
export function useRequestGetQuoteModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestGetQuoteModalQuery, RequestGetQuoteModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequestGetQuoteModalQuery, RequestGetQuoteModalQueryVariables>(RequestGetQuoteModalDocument, options);
        }
export type RequestGetQuoteModalQueryHookResult = ReturnType<typeof useRequestGetQuoteModalQuery>;
export type RequestGetQuoteModalLazyQueryHookResult = ReturnType<typeof useRequestGetQuoteModalLazyQuery>;
export type RequestGetQuoteModalSuspenseQueryHookResult = ReturnType<typeof useRequestGetQuoteModalSuspenseQuery>;
export type RequestGetQuoteModalQueryResult = Apollo.QueryResult<RequestGetQuoteModalQuery, RequestGetQuoteModalQueryVariables>;